export default "__VITE_ASSET__X61J_i3Z__"